/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit PlanBasic.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Info from 'DesignSystem/Info/view.js'
import PlanCellText from 'DesignSystem/PlanCellText/view.js'
import React from 'react'
import Title from 'DesignSystem/Title/view.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  width: 180,
height: 300,
paddingTop: 20,
alignItems: "center",
backgroundColor: "white",
borderBottomLeftRadius: 10,
borderBottomRightRadius: 10,
borderColor: "transparent",
borderStyle: "solid",
borderTopLeftRadius: 10,
borderTopRightRadius: 10,
borderWidth: 3,
boxShadow: "0px 10px 20px 0px rgba(0,162,255, 0.2)"})
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row"})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row"})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row"})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row"})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row"})

export default function PlanBasic({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="PlanBasic.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Vertical}`}
>
<Title
 data-testid="PlanBasic.Title"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/Title`}
 marginBottom={16}
 color="rgba(0,162,255, 1)"
 text="Basic"
/>
<Info
 data-testid="PlanBasic.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/Info`}
 textAlign="center"
 text="Cost"
 marginBottom={14}
/>
<div
 data-testid="PlanBasic.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Horizontal}`}
>
<PlanCellText
 data-testid="PlanBasic.PlanCellText"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="$18"
 marginRight={4}
/>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="/mo"
/>
</div>
<div
 data-testid="PlanBasic.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Horizontal1}`}
>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="$28"
 marginRight={4}
/>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="/mo"
/>
</div>
<div
 data-testid="PlanBasic.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Horizontal2}`}
>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="$35"
 marginRight={4}
/>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="/mo"
/>
</div>
<div
 data-testid="PlanBasic.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Horizontal3}`}
>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="$42"
 marginRight={4}
/>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="/mo"
/>
</div>
<div
 data-testid="PlanBasic.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
 className={`views-block ${styles.Horizontal4}`}
>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="$52"
 marginRight={4}
/>
<PlanCellText
 data-testid="PlanBasic.PlanCellText:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Show/EmployerContribution/Content/PlanBasic"
viewPath={`${viewPath}/PlanCellText`}
 text="/mo"
/>
</div>
</div>
{children}
</React.Fragment>)
}